import React from 'react'
import update from 'immutability-helper';
import { browserHistory } from 'react-router'

import { tenantBilling } from '../../core/controllers/TenantBilling';
import { modal } from '../../core/utilities/modal';
import { creditCardFormatter } from '../../helpers/General/CreditCardFormatter';

export default class TenantPayOnline extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            billing_setup: false,
            last_four: null,
            splash_information: null,
            customerData: {
                customer_name: '',
                customer_account_number: '',
                customer_routing_number: '',
                customer_bank_type: 8,
                customer_card_number: '',
                customer_exp_month: '',
                customer_exp_year: '',
                customer_card_type: 0
            },
            addCard: false,
            addBank: true
        };
    }

    componentDidMount() {
        var self = this;
        tenantBilling.getBillingInformation(function(billingInformation) {
            tenantBilling.getLatestInvoice(function(response) {
                // Implement ability to handle multiple invoices
                self.setState({
                    splash_information: billingInformation.splash_customer_token,
                    billing_setup: billingInformation.bank_account_last_four,
                    last_four: billingInformation.bank_account_last_four,
                });
            });
        });
    }

    handleSaveBilling() {
        var self = this;
        if(this.state.addBank) {
            this.handleSaveACH();
            return;
        }

        const customerData = this.state.customerData;
        //const cardEvent = this.cardEvent;
        //const card = this.card;
        if(customerData.customer_card_number == '' || typeof customerData.customer_card_number == 'undefined') {
            modal.showInfo('Missing Information! We need a valid credit card.', 'warning', 'top', 'center');
            return;
        }
        if(customerData.customer_exp_month == '' || typeof customerData.customer_exp_month == 'undefined') {
            modal.showInfo('Missing Information! We need a valid expiration month.', 'warning', 'top', 'center');
            return;
        }
        if(customerData.customer_exp_year == '' || typeof customerData.customer_exp_year == 'undefined') {
            modal.showInfo('Missing Information! We need a valid expiration year.', 'warning', 'top', 'center');
            return;
        }
        if(customerData.customer_card_number.length != 19) {
            modal.showInfo('Missing Information! We need a valid credit card.', 'warning', 'top', 'center');
            return;
        }
        if(customerData.customer_card_type == '' || typeof customerData.customer_card_type == 'undefined') {
            modal.showInfo('Missing Information! What type of credit card is this?', 'warning', 'top', 'center');
            return;
        }

        var creditCard = {
            card_number: customerData.customer_card_number,
            card_type: customerData.customer_card_type,
            expiration: customerData.customer_exp_month + customerData.customer_exp_year
        };

        tenantBilling.saveBillingInformation(creditCard, function(response) {
            modal.showInfo("Nice, your credit card was linked.  Enjoy easy payment online!", "success", "top", "center");
            browserHistory.goBack();
        });
    }

    handleSaveACH() {
        var self = this;
        const customerData = this.state.customerData;
        if(customerData.customer_routing_number == '' || typeof customerData.customer_routing_number == 'undefined') {
            modal.showInfo('Missing Information! We need the routing number.', 'warning', 'top', 'center');
            return;
        }
        if(customerData.customer_account_number == '' || typeof customerData.customer_account_number == 'undefined') {
            modal.showInfo('Missing Information! We need the account number.', 'warning', 'top', 'center');
            return;
        }
        if(customerData.customer_name == '' || typeof customerData.customer_name == 'undefined') {
            modal.showInfo('Missing Information! We need the account holder name.', 'warning', 'top', 'center');
            return;
        }

        var bankAccount = {
            routing_number: customerData.customer_routing_number,
            account_number: customerData.customer_account_number,
            account_holder_name: customerData.customer_name,
            account_holder_type: customerData.customer_bank_type
        };

        tenantBilling.saveBillingInformation(bankAccount, function(response) {
            modal.showInfo("Nice, your ACH account was linked.  Enjoy easy payment online!", "success", "top", "center");
            browserHistory.goBack()
        });
    }

    /* ACH Information */
    handleCustomerRoutingNumberChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_routing_number: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerAccountNumberChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_account_number: {$set: e.target.value
                }}
            )
        });
    }

    handleCustomerNameChange(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_name: {$set: e.target.value
                }}
            )
        });
    }

    toggleForm(e) {
        this.setState({
            showForm: this.state.showForm ? false : true
        });
    }

    handleCustomerBankType(e){
        this.setState({
            customerData: update(this.state.customerData, {
                customer_bank_type: {$set: e.target.value
                }}
            )
        });
    }

    ACH(e) {
        this.setState({
            addBank: true,
            addCard: false
        });
    }

    creditCard(e) {
        this.setState({
            addCard: true,
            addBank: false
        });
    }

    handleCustomerCardNumber(e){
        var number = creditCardFormatter.format(e.target.value);

        this.setState({
            customerData: update(this.state.customerData, {
                customer_card_number: {$set: number
                }}
            )
        });
    }

    handleCustomerExpirationMonthChange(e){
        var month = e.target.value.replace(/\D/g,'');

        if(month.length > 2) {
            return;
        }

        this.setState({
            customerData: update(this.state.customerData, {
                customer_exp_month: {$set: month
                }}
            )
        });
    }

    handleCustomerExpirationYearChange(e){
        var year = e.target.value.replace(/\D/g,'');

        if(year.length > 2) {
            return;
        }

        this.setState({
            customerData: update(this.state.customerData, {
                customer_exp_year: {$set: year
                }}
            )
        });
    }

    handleCardTypeChange(e) {
        this.setState({
            customerData: update(this.state.customerData, {
                customer_card_type: {$set: e.target.value
                }}
            )
        });
    }

    render(){
        const billingSetup = this.state.billingSetup;
        const lastFour = this.state.lastFour;
        const customerData = this.state.customerData;
        
        const addBank = this.state.addBank;
        const addCard = this.state.addCard;

        if(true){
            return(
                <div>
                <div class="row blue-bottom-margin">
                    <div class="row">
                        <div class="sub-page-header-row col-md-11">
                            <div class="row">
                                <span class="sub-page-header-title">Add a Payment Account</span>
                            </div>
                            <div class="row">
                                <span class="sub-page-header-sub-title">Set up a payment account to make payments online</span>
                            </div>  
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="content">
                                    <form>
                                        <div class="row">
                                            <div class="col-md-2 col-sm-6 col-xs-12"></div>
                                            <div class="col-md-4 col-sm-6 col-xs-12">
                                                { addBank == true ? (
                                                <div class="info-box selected-border" style={{cursor: 'pointer'}} onClick={this.ACH.bind(this)}>
                                                    <span class="info-box-icon yellow-icon-circle" style={{paddingTop: '0px'}}><i class="pe-7s-wallet"></i></span>
                                                    <div class="info-box-content" style={{textAlign: 'center', verticalAlign: 'middle', lineHeight: '90px'}}>
                                                        <span class="info-box-text">Bank Account</span>
                                                    </div>
                                                </div>
                                                ) : (
                                                <div class="info-box" style={{cursor: 'pointer'}} onClick={this.ACH.bind(this)}>
                                                    <span class="info-box-icon yellow-icon-circle" style={{paddingTop: '0px'}}><i class="pe-7s-wallet"></i></span>
                                                    <div class="info-box-content" style={{textAlign: 'center', verticalAlign: 'middle', lineHeight: '90px'}}>
                                                        <span class="info-box-text">Bank Account</span>
                                                    </div>
                                                </div>
                                                )}
                                            </div>
                                            <div class="col-md-4 col-sm-6 col-xs-12">
                                                { addBank == false ? (
                                                    <div class="info-box selected-border" style={{cursor: 'pointer'}} onClick={this.creditCard.bind(this)}>
                                                        <span class="info-box-icon blue-icon-circle" style={{paddingTop: '0px'}}><i class="pe-7s-credit"></i></span>
                                                        <div class="info-box-content" style={{textAlign: 'center', verticalAlign: 'middle', lineHeight: '90px'}}>
                                                            <span class="info-box-text">Credit Card</span>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div class="info-box" style={{cursor: 'pointer'}} onClick={this.creditCard.bind(this)}>
                                                        <span class="info-box-icon blue-icon-circle" style={{paddingTop: '0px'}}><i class="pe-7s-credit"></i></span>
                                                        <div class="info-box-content" style={{textAlign: 'center', verticalAlign: 'middle', lineHeight: '90px'}}>
                                                            <span class="info-box-text">Credit Card</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {addBank ? (
                                            <div>
                                                <div class="row">
                                                    <div class="col-md-4 col-md-offset-2">
                                                        <div class="form-group">
                                                            <label for="phone">Routing Number</label>
                                                            <input type="text" value={customerData.customer_routing_number} class="form-control tenant-info" name="routing" placeholder="Routing Number" id="routing" onChange={this.handleCustomerRoutingNumberChange.bind(this)}/>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <label for="phone">Account Number</label>
                                                            <input type="text" value={customerData.customer_account_number} class="form-control tenant-info" name="account" placeholder="Account Number" id="account" onChange={this.handleCustomerAccountNumberChange.bind(this)}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-4 col-md-offset-2">
                                                        <div class="form-group">
                                                            <label for="phone">Account Holder Name</label>
                                                            <input type="text" value={customerData.customer_name} class="form-control tenant-info" name="name" placeholder="Account Holder Name" id="name" onChange={this.handleCustomerNameChange.bind(this)}/>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <label for="phone">Account Type</label>
                                                            <select class="form-control" value={customerData.bank_type} onChange={this.handleCustomerBankType.bind(this)}>
                                                                <option value='8'>Checking Account</option>
                                                                <option value='9'>Savings Account</option>
                                                                <option value='10'>Corporate Checking Account</option>
                                                                <option value='11'>Corporate Savings Account</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ):(
                                            <div>
                                                <div class="row">
                                                    <div class="col-md-6 col-md-offset-2">
                                                        <div class="form-group">
                                                            <label for="phone">Card Number</label>
                                                            <input type="text" value={customerData.customer_card_number} class="form-control tenant-info" name="cardnumber" placeholder="Credit Card" id="cardnumber" onChange={this.handleCustomerCardNumber.bind(this)}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3 col-md-offset-2">
                                                        <div class="form-group">
                                                            <label for="phone">Expiration Month</label>
                                                            <input type="text" value={customerData.customer_exp_month} class="form-control tenant-info" name="month" placeholder="01" id="month" onChange={this.handleCustomerExpirationMonthChange.bind(this)}/>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <div class="form-group">
                                                            <label for="phone">Expiration Year</label>
                                                            <input type="text" value={customerData.customer_exp_year} class="form-control tenant-info" name="year" placeholder="22" id="year" onChange={this.handleCustomerExpirationYearChange.bind(this)}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-4 col-md-offset-2">
                                                        <div class="form-group">
                                                            <label for="cardtype">Card Type</label>
                                                            <select class="form-control" value={customerData.bank_type} onChange={this.handleCardTypeChange.bind(this)}>
                                                                <option value='0'>Select a Card Type</option>
                                                                <option value='1'>American Express</option>
                                                                <option value='2'>Visa</option>
                                                                <option value='3'>MasterCard</option>
                                                                <option value='4'>Diners Club</option>
                                                                <option value='5'>Discover</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row blue-bottom" style={{marginLeft:"-50px"}}>
                    <div class="blue-bottom-center-align">
                        { billingSetup === false ? (
                            <div class="col-md-12">
                                <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.handleSaveBilling.bind(this)}>
                                Save
                                </button>
                            </div>
                        ) : (
                            <div class="col-md-12">
                                <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.handleSaveBilling.bind(this)}>
                                Update
                                </button>
                            </div>
                        )}
                        <div class="clearfix"></div>
                    </div>
                </div>
                </div>
            );
        }
    }
};


// WEBPACK FOOTER //
// app/components/Billing/TenantPayOnlineForm.jsx